module.exports = __webpack_public_path__ + "img/img-abt2.47cf44c9.jpg";